module.exports = __webpack_public_path__ + "img/numeralia_home3.1a416df4.svg";